import { mapCmsImageToImageProps } from '@/lib/cms-mappers/common.mappers';

import type { FcwBlogPostCardProps } from '@/components/organisms/FcwBlogPostCard.vue';

export function mapCmsBlogPostsToBlogPostCardsProps(
  blogPostsRawData: StrapiResponseData<BlogPostContentType>[] | undefined
): FcwBlogPostCardProps[] {
  return (blogPostsRawData ?? []).map(card => ({
    title: card.attributes?.title ?? '',
    slug: card.attributes?.slug ?? '',
    date: card.attributes?.publishedAt,
    image: mapCmsImageToImageProps(card.attributes?.hero_image, 'medium'),
    background:
      card.attributes.background_color &&
      card.attributes.second_background_color
        ? [
            card.attributes.background_color,
            card.attributes.second_background_color,
          ]
        : card.attributes.background_color ?? undefined,
  }));
}
